export const getFormData = (object: {[name: string]: string | Blob}) => {
  return Object.entries(object).reduce((fd, [key, val]) => {
    if (Array.isArray(val)) {
      val.forEach(v => fd.append(key, v));
    } else {
      if (val) {
        fd.append(key, val);
      }
    }
    return fd;
  }, new FormData());
};

export const convertObjToFormData = (
  object: Record<string, string | Blob | (string | Blob)[]>,
) => {
  const formData = new FormData();

  for (const [key, value] of Object.entries(object)) {
    if (value == null) continue;

    if (Array.isArray(value)) {
      value.forEach(item => formData.append(key, item));
    } else {
      formData.append(key, value);
    }
  }

  return formData;
};

export const secondaryGetFormData = (object: {
  [name: string]: string | Blob;
}) => {
  return Object.entries(object).reduce((fd, [key, val]) => {
    if (Array.isArray(val)) {
      val.forEach(v => fd.append(key, v));
    } else {
      if (val !== undefined && val !== null) {
        // if (val !== undefined) {
        fd.append(key, val);
      }
    }
    return fd;
  }, new FormData());
};

export const LabSecondaryGetFormData = (object: {
  [name: string]: string | Blob;
}) => {
  return Object.entries(object).reduce((fd, [key, val]) => {
    if (Array.isArray(val)) {
      val.forEach(v => fd.append(key, v));
    } else {
      if (val !== undefined) {
        fd.append(key, val);
      }
    }
    return fd;
  }, new FormData());
};

export const createYearFromNowUntilPast = (numberYear: number) => {
  const arrayYear = [];
  for (let i = 0; i < numberYear; i++) {
    arrayYear.push(
      new Date(
        new Date().setFullYear(new Date().getFullYear() - i),
      ).toLocaleDateString('fa-IR', {year: 'numeric'}),
    );
  }
  return arrayYear;
};
